import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
import Slider from "react-slick"
import { Link } from 'react-router-dom'

import { throttle, isMobile, equalHeight } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import ObjPushCardFormation from './ObjPushCardFormation'

import '../../assets/css/0020_objects/0730_obj_direct_comptoir_dermato.css'
import '../../assets/css/0020_objects/0621_obj_carrousel_slider.css'

class ObjDirectComptoirDermato extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile()
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
		this.handleButtonFav = this.props.handleButtonFav.bind(this)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
		this.applyEqualHeight()
	}

	componentDidMount() {
		this.applyEqualHeight()
		window.addEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
	}

	applyEqualHeight() {
		setTimeout(() => {
			equalHeight(".obj_direct_comptoir_dermato .obj_push_card .ctn_text_card");
		});
	}

    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

	render() {
        const { datasTrainings, dataType, datasComptoir } = this.props;

		const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: true,
			infinite: false,
			slidesToShow: 1,
			swipeToSlide: true,
            onSwipe: this.onSwipe.bind(this),
			// variableWidth: true,
			centerPadding: "10%",
            dots: true,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: false,
            speed: 750,
        }

		return (<>{datasTrainings && !(datasTrainings.length < 1 && dataType==="ThemeAv") && <>
			<div className="obj_direct_comptoir_dermato">
				<div className="ctn_title">
					<h3 className="t_title">{dataType==="ThemeAv" ? "Pour aller plus loin" : "En direct du comptoir dermato" }</h3>
				</div>

                {datasTrainings.length < 1 ? 
                    <div className="ctn_text">
                        {/* <h4 className="t_title">Lorem ipsum</h4> */}
                        <p> Approfondissez votre expertise dermatologique en direct du <Link to={datasComptoir.url}>Comptoir dermato</Link></p>
                    </div>
                :
                    <>
                        { this.state.isMobile &&
                            <div className="ctn_carrousel">
                                <Slider {...settings} ref={sliderRef}>
                                    {datasTrainings.map((datasTraining, index) => (
                                        <div className="item" key={index} >
                                            <ObjPushCardFormation typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        }

                        {!this.state.isMobile &&
                            <div className="ctn_row">
                                {datasTrainings.map((datasTraining, index) => (
                                    <ObjPushCardFormation key={index} typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                                ))}
                            </div>
                        }
                    </>
                }
			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjDirectComptoirDermato));